<template lang="pug">
  v-app
    transition(name="fade", mode="out-in")
      keep-alive(exclude="home,chatWithReferral")
        router-view
    notifications(
      ref="notification",
      group="kick",
      position="bottom right",
      classes="vue-notification")
      template(slot="body", slot-scope="props")
        .vue-notification
          v-layout
            .avatar(v-if="props.item.data.type !== 3")
              //- div
              //-   SvgMsgBubble
              div(
                v-if="props.item.data.payload.photo_url",
                :style="{ 'background-image': 'url(' + avatarUrlWithResize(props.item.data.payload.photo_url, '32x32') + ')' }")
              AvatarPlaceholder.notification(
                v-else,
                :fullName="props.item.data.payload.first_name + ' ' + props.item.data.payload.last_name",
                :classname="getAvatarClass(props.item.data.payload.first_name, props.item.data.payload.last_name)")
            .message
              v-layout.message_head(align-center)
                .secondary_txt(:class="{ double: props.item.data.type === 2 }") {{ getNotificationTitle(props.item) }}
                SvgArrowThin(v-if="props.item.data.type === 2")
                .secondary_txt.double(v-if="props.item.data.type === 2") {{ props.item.data.payload.group_name }}
              .message_txt {{ getNotificationText(props.item) }}
              v-layout.message_foot(align-center)
                .secondary_txt {{ props.item.data.created | messageTime($i18n.locale) }}
                .action(v-if="props.item.data.type === 2", @click="onReplyClick(props)") {{ $t('actions.reply') }}
          v-layout.chat_input(v-if="props.item.data.type === 1", align-start)
            v-textarea(
              auto-grow,
              solo,
              hide-details,
              :rows="1",
              :placeholder="$t('actions.yourReply')",
              @input="val => newMessages[props.item.data.id] = val"
              @keydown="ev => onNewMessageKeyDown(ev, props)",
              @focus="onInputFocus(props.item.data.id)")
            .input_btn.input_send(@click="sendMessage(props)")
              SvgMsgSend
          .vue-notification_close(@click="readNotification(props)")
            SvgPlus
    v-snackbar(
      v-if="!!reconnectionAttempts",
      v-model="snackbar",
      top,
      color="error",
      :timeout="60*60*1000") {{ $t('hints.connectionLost') }}
</template>

<script>
import { mapState } from 'vuex';
import notifyWS from '@/ws';
import SvgArrowThin from '@/components/svg/SvgArrowThin';
import AvatarPlaceholder from '@/components/AvatarPlaceholder';
import SvgPlus from '@/components/svg/SvgPlus';
import SvgMsgBubble from '@/components/svg/SvgMsgBubble';
import SvgMsgSend from '@/components/svg/SvgMsgSend';
import { SET_ACTIVE_CHAT } from '@/store/modules/chats/types';
import {
  SET_WS_STATE,
  SET_WS_AUTH
  // READ_NOTIFICATION
} from '@/store/modules/notify/types';
import { getAvatarClass, avatarUrlWithResize, cutStringInChunks } from '@/utils';
import CONSTANTS from '@/constants';
import socket from '@/socket';

export default {
  components: {
    SvgArrowThin,
    AvatarPlaceholder,
    SvgPlus,
    SvgMsgBubble,
    SvgMsgSend
  },
  data() {
    return {
      snackbar: true,
      getAvatarClass,
      avatarUrlWithResize,
      newMessage: '',
      newMessages: {},
      maxMessageLength: CONSTANTS.maxMessageLength,
      sendingMsg: false,
      activeInputChatId: null,
      dev: [],
      notificationTimeouts: {},
      notificationDuration: 5000
    };
  },
  mounted() {
    // turn devMode for moderation menu visibility
    if (process.env.VUE_APP_ENV !== 'prod') {
      document.addEventListener('keyup', e => {
        if (e.shiftKey) {
          if (this.dev.length >= 4) this.dev.length = 3;
          this.dev.unshift(e.keyCode);
          if (this.dev.join('') === '75677375') this.$store.dispatch('develop/activate');
        }
      });
    }

    this.$eventHub.$on('notifyWSopened', () => this.$store.commit(`notify/${SET_WS_STATE}`, true));
    this.$eventHub.$on('notifyWSclosed', () => this.$store.commit(`notify/${SET_WS_STATE}`, false));
    this.$eventHub.$on('notifyWSauth', () => this.$store.commit(`notify/${SET_WS_AUTH}`, true));
    this.$eventHub.$on('messageNotification', this.handleMessageNotification);
  },
  beforeDestroy() {
    this.$eventHub.$off('notifyWSopened');
    this.$eventHub.$off('notifyWSclosed');
    this.$eventHub.$off('notifyWSauth');
    this.$eventHub.$off('messageNotification');
  },
  computed: {
    ...mapState('chats', [
      'activeChat',
      'recentChats',
      'reconnectionAttempts'
    ]),
    loggedIn() {
      return this.$store.state.user.loggedIn;
    },
    notifyWSopen() {
      return this.$store.state.notify.WSopen;
    }
  },
  watch: {
    loggedIn(val) {
      if (val) {
        notifyWS.init();
      } else {
        notifyWS.close(1000);
      }
    },
    notifyWSopen(val) {
      if (val && localStorage.getItem('access_token')) {
        notifyWS.authenticate(localStorage.getItem('access_token'));
      }
    },
    newMessages: {
      handler(val) {
        return val;
      },
      deep: true
    }
  },
  methods: {
    onInputFocus(notificationId) {
      if (!this.newMessages[notificationId]) {
        this.newMessages[notificationId] = '';
      }

      if (this.notificationTimeouts[notificationId]) {
        clearTimeout(this.notificationTimeouts[notificationId]);
      }
    },
    onNewMessageKeyDown(event, props) {
      if (event.keyCode !== 13) return;

      if (!event.shiftKey && !event.ctrlKey) {
        event.preventDefault();
        this.sendMessage(props);
      }

      if (event.ctrlKey) this.newMessage += '\n';
    },
    sendMessage(props) {
      let message = this.newMessages[props.item.data.id];
      if (!message || !message.trim().length || this.sendingMsg) return;

      this.sendingMsg = true;
      message = message.replace(/^\n+|\n+$/g, '');

      if (message.length <= 2048) {
        this.sendSingleMessage(message, props);
      } else {
        const chunks = cutStringInChunks(message, this.maxMessageLength);

        chunks.forEach(chunk => {
          this.sendSingleMessage(chunk, props);
        });
      }
    },
    sendSingleMessage(message, props) {
      const chatId = props.item.data.payload.chat_id;
      const request = {
        type: 'message',
        payload: { chat_id: chatId, message }
      };
      const responseCb = response => {
        if (response.errors) {
          // TODO: handle errors in ack function
          console.error(response.errors);
        }
      };

      // TODO: get chat message ID in order to read it
      // this.readMessage()
      socket.emit(request.type, request.payload, responseCb);
      this.sendingMsg = false;
      this.readNotification(props);
    },
    readNotification(notification) {
      notifyWS.readNotification(notification.item.data.id);
      notification.close();
    },
    readMessage(messageId) {
      const message = this.getMessageById(messageId);

      if (message && !message.is_read) {
        socket.emit('read-message', { message_id: messageId });
      }
    },
    getNotificationTitle({ title, data: { type, payload } }) {
      return type === 3 ? title : `${payload.first_name} ${payload.last_name}`;
    },
    getNotificationText({ text, data: { type, payload } }) {
      return type === 3 ? text : payload.text;
    },
    onReplyClick(props) {
      const chatId = props.item.data.payload.chat_id;
      const chat = this.recentChats.find(i => i.id === chatId);

      if (chat && (!this.activeChat || chatId !== this.activeChat.id)) {
        this.$eventHub.$emit('chatClicked');
        this.$store.commit(`chats/${SET_ACTIVE_CHAT}`, chat);
      }

      notifyWS.readNotification(props.item.data.id);
      props.close();
    },
    closeNotificationById(notificationId) {
      const item = this.$refs.notification.list.find(i => i.data.id === notificationId);

      if (item) {
        this.$refs.notification.destroyById(item.id);
      }
    },
    handleMessageNotification(notificationId) {
      this.notificationTimeouts[notificationId] = setTimeout(() => this.closeNotificationById(notificationId), this.notificationDuration);
    }
  }
};
</script>

<style lang="scss">
@import './assets/scss/variables';
@import './assets/scss/notifications';

html {
  font-family: Gilroy, Helvetica, Roboto, Arial, sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $light-theme-primary-text;
}

// v-app
#app {
  background: $white !important;
  font-family: Gilroy, Helvetica, Roboto, Arial, sans-serif !important;
  opacity: 1;
  transition: opacity .5s $easing;
  &.leaving { opacity: 0; }
}

// transition animation
.fade-enter-active,
.fade-leave-active {
  transition: all .3s $easing;
}

.fade-enter {
  // transform: translate(-20%);
  opacity: 0;
}

.fade-leave-to {
  // transform: translate(50%);
  opacity: 0;
}
</style>
